import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Group, Matrix } from 'src/app/common-class/pages';
import { Answers } from 'src/app/common-class/answers';
import { CommonLogic } from 'src/app/common-logic/common-logic';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { SurveyMessages } from 'src/app/common-class/survey-messages';
import { PostMessgesData } from 'src/app/common-class/Post-message-data';
declare var $: any;

@Component({
  selector: 'app-drill-down',
  templateUrl: './drill-down.component.html',
  styleUrls: ['./drill-down.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class DrillDownComponent implements OnInit {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() group: Group;
  @Input() matrix: Matrix;
  @Input() isMobile: boolean;
  @Input() DropDown: string;
  @Input() isNewParticipationButton: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  postMessgesData:PostMessgesData;

  tempArray = [];
  questionsArray: any;
  checkDrillDown: number = 0;
  prevValue: any;
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean = false;
  surveyMessages: SurveyMessages;
  isNewParticipation: boolean;
  surveyFormat:number = 0;
  newParticipationBtnText: string;
  isAnsChange:boolean = false;
  resetPageSub: any;
  isFirstSubQHide:boolean = false;

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
      this.onLoadValue();
      this.ngAfterViewInit();
    }
  }

  constructor(private service: ParticipationDataService) {
  }

  ngOnInit() {
    if (this.questions == null) {
      this.surveyMessages= this.service.getSurveyMessages();
      this.questions = JSON.parse(this.JsonData);
      let imgQn = this.questions.find(e => e.sub_qno == 1);
      if (imgQn != undefined && imgQn != null) {
        this.imgQuestion = imgQn;
      }
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i].answer_style == 1 && this.questions[i].Answers != null) {
          this.questions[i].Answers = CommonLogic.RandomAnswerHandling(this.questions[i]);
        }
      }
      if(this.group.answer_style == 0 && this.questions.length > 1)
      {
        this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
      }
      this.onLoadValue();
    }

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;

    // if(this.questions.filter(e=>e.sub_qno==1 && e.population_type == 2).length>0)
    // {
    //   this.isFirstSubQHide = true;
    // }

  }

  onLoadValue(){
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i].selectAnsValue == undefined) {
        this.questions[i].selectAnsValue = 0;
      } else  if(this.questions[i].selectAnsValue > 0){
        this.checkDrillDown = 1;
      } else if(this.questions[i].selectAnsValue == -1){
        this.questions[i].selectAnsValue = 0;
      }
    }
  }

  ngAfterViewInit() {
    // $(document).click(function () {
    //   if (!$(event.target).parents().hasClass('drill-down-search')) {
    //     $('.drill-down-search').removeClass('showDrillList');
    //   }
    // });
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if(data) {
        this.isAnsChange =false;
      }
    });
  }

  ngOnDestroy(){
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  SelectedValue(answer: any, question: Questions, index: number) {
    this.isAnsChange=true;
    if (answer === "0") {
      this.ResetControl(index);
      return;
    } else {
      for (let i = 0; i < question.Answers.length; i++) {
        if (answer == question.Answers[i].value_id) {

          if (question.isLoading) {
            this.ResetControl(index + 1);
          }

          //answer.selectdId = 1;
          question.Answers[i].selectdId = 1;
          question.AnswerID = question.Answers[i].ms_id;
          question.selectAnsValue = question.Answers[i].value_id;
          question.AnswerText = question.Answers[i].value_text;
          question.pageto = question.Answers[i].pageto;
          question.otherAnswer = null;
          question.isLoading = true;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (question.Answers[i].isOther) {
            question.isOtherAnswer = true;
          }
          else {
            question.isOtherAnswer = false;
          }
        }
        else {
          question.Answers[i].ControlAns = null;
          question.Answers[i].selectdId = 0;
        }
      }
    }

    this.ChangeAnswersData.emit(question);
  }

  ResetControl(index: number) {
    for (let i = index; i < this.questions.length; i++) {
      if (this.questions[i].isLoading) {
        this.questions[i].selectAnsValue = 0;
        this.questions[i].isOtherAnswer = false;
        this.questions[i].selectAnsValue = 0;
        this.questions[i].AnswerID = 0;
        this.questions[i].AnswerText = null;
        this.questions[i].isLoading = false;
        this.ChangeAnswersData.emit(this.questions[i]);
      }
    }
  }

  GetSelectedAnswer(index: number, question: Questions): Answers[] {

    if (index == 0) {
      return question.Answers;
    } else if (index > 0) {

      if (this.questions[index - 1].selectAnsValue > 0) {
        return question.Answers.filter(e => e.ParentMsId == this.questions[index - 1].AnswerID);
      }
    }
    return null;
  }

  findIndexToUpdate(answer) {
    return answer === this;
  }

  GetQuestionsString(question: Questions, index: number): string {
    return JSON.stringify(question);
  }

  setDrillDownValue(valueId: any, question: Questions, index: number, self) {
    self.SelectedValue(valueId, question, index)
  }

  showDDList(event) {
    if ($(event.target).closest('.drill-down-search').hasClass('showDrillList')) {
      $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      $(event.target).closest('.drill-down-input').attr("aria-expanded", "false");
    } else {
      $('.drill-down-search').removeClass('showDrillList');
      $(event.target).closest('.drill-down-search').addClass('showDrillList');
      $(event.target).closest('.drill-down-search').find('.drill-down-input').focus();
      $(event.target).closest('.drill-down-search').find('.drill-down-list-item').show();
    }
  }

  selectDDListItem(event, question: Questions, index: number) {
    var self = this;
    $(event.target).closest('.drill-down-search').find('.drill-down-input').val('');
    $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
      $(this).html($(this).attr('ogListValue'));
      $(this).show();
      $(this).html(self.highlight($(this).html(), ''));
    });
    let itemText = $(event.target).attr('ogListValue');
    let itemValue = $(event.target).attr('list-value');
    $(event.target).closest('.drill-down-search').find('select').val(itemValue);
    $(event.target).closest('.drill-down-search').find('.drill-down-input').val(itemText);
    $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    self.checkDrillDown = 1;
    self.setDrillDownValue(itemValue, question, index, self);
  }

  setDDListItem(event, question: Questions, index: number) {
    var self = this;
    setTimeout(function () {
      if (self.checkDrillDown == 0 && self.checkDrillDown != undefined) {
        const ddSearchValue = $(event.target).val().toLowerCase();
        // const currentInput = $(this);
        if (ddSearchValue !== '') {
          $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
            $(this).html($(this).attr('ogListValue'));
            if (ddSearchValue === $(this).text().toLowerCase()) {
              $(event.target).val($(this).attr('ogListValue'));
              // $(event.target).closest('.drill-down-search').removeClass('showDrillList');
              const itemValue = $(this).attr('list-value');
              $(this).closest('.drill-down-search').find('select').val(itemValue);
              self.setDrillDownValue(itemValue, question, index, self);
              return false;
            } else {
              $(event.target).val('');
              $(this).closest('.drill-down-search').find('select').val('0');
              question.AnswerText=null;
              self.setDrillDownValue("0", question, index, self);
            }
          });
        } else {
          question.AnswerText=null;
          self.setDrillDownValue("0", question, index, self);
        }
      }
      if ( self.service.getCommonSetting().isEmbedNoScroll && window.location !== window.parent.location) {
        let docHeight = document.documentElement.scrollHeight;
        if ($('form').height() != undefined && $('form').height() != 0) {
          docHeight = $('form').height();
        }
        self.postMessgesData = new PostMessgesData()
        self.postMessgesData.action = 'Drill Down Change';
        self.postMessgesData.data = '';
        self.postMessgesData.height = docHeight + (self.service.getCommonSetting().embedDefaultPx? self.service.getCommonSetting().embedDefaultPx : 0 );
        self.postMessgesData.width = document.documentElement.scrollWidth;
        self.postMessgesData.embedid = this.service.commonSetting.embedID;
        parent.postMessage(JSON.stringify(self.postMessgesData), "*");
      } 
    }, 1);
    // $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    
  }


  filterDDSearch(event) {
    var self = this;
    var keyCode = event.keyCode || event.which;
    if(keyCode == 13 || keyCode == undefined){
      event.preventDefault();
      $(event.target).blur();
      setTimeout(function (){
        $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      }, 100);
    }
    setTimeout(function () {
      var keyCode = event.keyCode || event.which;
      if(keyCode !== 9){
        $(event.target).closest('.drill-down-search').addClass('showDrillList');
        if(keyCode == 40){
          event.preventDefault();
          if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'))){
            $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'));
            $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
            $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').addClass('currentActiveDDITem');
            $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
          } else {
            var nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').nextAll('.drill-down-list-item:visible:first');
            if(nextElement.length > 0){
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              nextElement.addClass('currentActiveDDITem');
            } else {
              nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              nextElement.addClass('currentActiveDDITem');
            }
          }

          var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
          var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
          var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
          var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

          if(elementPosWithHt > scrollableDivPosWithHt){
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
          } else if(elementPos < scrollableDivPos) {
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
          }

        } else if(keyCode == 38) {
          event.preventDefault();
          if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'))){
            $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'));
            $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
            $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').addClass('currentActiveDDITem');
            $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
          } else {
            // $(event.target).closest('.drill-down-search').find('select').val(parseInt($(event.target).closest('.drill-down-search').find('select').val()) - 1);
            // $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());

            var prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').prevAll('.drill-down-list-item:visible:first');
            if(prevElement.length > 0){
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              prevElement.addClass('currentActiveDDITem');
            } else {
              prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              prevElement.addClass('currentActiveDDITem');
            }
          }
          var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
          var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
          var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
          var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

          if(elementPosWithHt > scrollableDivPosWithHt){
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
          } else if(elementPos < scrollableDivPos) {
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
          }
        } else {
          $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
          $(event.target).closest('.drill-down-search').find('select').val('-1');
          const ddSearchValue = $(event.target).val().toLowerCase();
          if (ddSearchValue !== '') {
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
              $(this).html($(this).attr('ogListValue'));
              if ($(this).text().toLowerCase().indexOf(ddSearchValue) !== -1) {
                $(this).show();
                $(this).html(self.highlight($(this).html(), ddSearchValue));
              } else {
                $(this).hide();
              }
            });
            if ($(event.target).closest('.drill-down-search').find('.drill-down-list-item:visible').length === 0) {
              $(event.target).closest('.drill-down-search').removeClass('showDrillList');
            } else {
              $(event.target).closest('.drill-down-search').addClass('showDrillList');
            }
          } else {
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').show();
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
              $(this).html($(this).attr('ogListValue'));
            });
          }
          if($(event.target).val() != self.prevValue){
            self.checkDrillDown = 0;
          } else {
            self.checkDrillDown = 1;
          }
        }
      } else {
        $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      }

      if ( self.service.getCommonSetting().isEmbedNoScroll && window.location !== window.parent.location) {
        let docHeight = document.documentElement.scrollHeight;
        if ($('form').height() != undefined && $('form').height() != 0) {
          docHeight = $('form').height();
        }
        self.postMessgesData = new PostMessgesData()
        self.postMessgesData.action = 'Drill Down Change';
        self.postMessgesData.data = '';
        self.postMessgesData.height = docHeight + (self.service.getCommonSetting().embedDefaultPx? self.service.getCommonSetting().embedDefaultPx : 0 );
        self.postMessgesData.width = document.documentElement.scrollWidth;
        self.postMessgesData.embedid = this.service.commonSetting.embedID;
        parent.postMessage(JSON.stringify(self.postMessgesData), "*");
        console.log(JSON.stringify(self.postMessgesData))
      } 

    }, 1);
  }


  // filterDDSearch(event) {
  //   var self = this;
	// var DrillDownSerch = $(event.target).closest('.drill-down-search');
  //   var keyCode = event.keyCode || event.which;
  //   if(keyCode == 13 || keyCode == undefined){
  //     event.preventDefault();
  //     $(event.target).blur();
  //     setTimeout(function (){
  //       DrillDownSerch.removeClass('showDrillList');
  //     }, 100);
  //   }
  //   setTimeout(function () {
  //     var keyCode = event.keyCode || event.which;
  //     if(keyCode !== 9){
  //       DrillDownSerch.addClass('showDrillList');
  //       if(keyCode == 40){
  //         event.preventDefault();
  //         if(DrillDownSerch.find('select').val() <= 0 || DrillDownSerch.find('select').val() == parseInt(DrillDownSerch.find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'))){
  //           DrillDownSerch.find('select').val(DrillDownSerch.find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'));
  //           DrillDownSerch.find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //           DrillDownSerch.find('.drill-down-list .drill-down-list-item:visible:first').addClass('currentActiveDDITem');
  //           $(event.target).val(DrillDownSerch.find('select option:selected').text());
  //         } else {
  //           var nextElement = DrillDownSerch.find('.currentActiveDDITem').nextAll('.drill-down-list-item:visible:first');
  //           if(nextElement.length > 0){
  //             DrillDownSerch.find('select').val(parseInt(nextElement.attr('list-value')));
  //             $(event.target).val(DrillDownSerch.find('select option:selected').text());
  //             DrillDownSerch.find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //             nextElement.addClass('currentActiveDDITem');
  //           } else {
  //             nextElement = DrillDownSerch.find('.currentActiveDDITem');
  //             DrillDownSerch.find('select').val(parseInt(nextElement.attr('list-value')));
  //             $(event.target).val(DrillDownSerch.find('select option:selected').text());
  //             DrillDownSerch.find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //             nextElement.addClass('currentActiveDDITem');
  //           }
  //         }

  //         var elementPos = DrillDownSerch.find('.currentActiveDDITem').offset().top;
  //         var elementPosWithHt = DrillDownSerch.find('.currentActiveDDITem').offset().top + DrillDownSerch.find('.currentActiveDDITem').outerHeight();
  //         var scrollableDivPos = DrillDownSerch.find('.drill-down-list').offset().top;
  //         var scrollableDivPosWithHt = DrillDownSerch.find('.drill-down-list').offset().top + DrillDownSerch.find('.drill-down-list').outerHeight();

  //         if(elementPosWithHt > scrollableDivPosWithHt){
  //           DrillDownSerch.find('.drill-down-list').scrollTop(DrillDownSerch.find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
  //         } else if(elementPos < scrollableDivPos) {
  //           DrillDownSerch.find('.drill-down-list').scrollTop(DrillDownSerch.find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
  //         }

  //       } else if(keyCode == 38) {
  //         event.preventDefault();
  //         if(DrillDownSerch.find('select').val() <= 0 || DrillDownSerch.find('select').val() == parseInt(DrillDownSerch.find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'))){
  //           DrillDownSerch.find('select').val(DrillDownSerch.find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'));
  //           DrillDownSerch.find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //           DrillDownSerch.find('.drill-down-list .drill-down-list-item:visible:last').addClass('currentActiveDDITem');
  //           $(event.target).val(DrillDownSerch.find('select option:selected').text());
  //         } else {
  //           // DrillDownSerch.find('select').val(parseInt(DrillDownSerch.find('select').val()) - 1);
  //           // $(event.target).val(DrillDownSerch.find('select option:selected').text());

  //           var prevElement = DrillDownSerch.find('.currentActiveDDITem').prevAll('.drill-down-list-item:visible:first');
  //           if(prevElement.length > 0){
  //             DrillDownSerch.find('select').val(parseInt(prevElement.attr('list-value')));
  //             $(event.target).val(DrillDownSerch.find('select option:selected').text());
  //             DrillDownSerch.find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //             prevElement.addClass('currentActiveDDITem');
  //           } else {
  //             prevElement = DrillDownSerch.find('.currentActiveDDITem');
  //             DrillDownSerch.find('select').val(parseInt(prevElement.attr('list-value')));
  //             $(event.target).val(DrillDownSerch.find('select option:selected').text());
  //             DrillDownSerch.find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //             prevElement.addClass('currentActiveDDITem');
  //           }
  //         }
  //         var elementPos = DrillDownSerch.find('.currentActiveDDITem').offset().top;
  //         var elementPosWithHt = DrillDownSerch.find('.currentActiveDDITem').offset().top + DrillDownSerch.find('.currentActiveDDITem').outerHeight();
  //         var scrollableDivPos = DrillDownSerch.find('.drill-down-list').offset().top;
  //         var scrollableDivPosWithHt = DrillDownSerch.find('.drill-down-list').offset().top + DrillDownSerch.find('.drill-down-list').outerHeight();

  //         if(elementPosWithHt > scrollableDivPosWithHt){
  //           DrillDownSerch.find('.drill-down-list').scrollTop(DrillDownSerch.find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
  //         } else if(elementPos < scrollableDivPos) {
  //           DrillDownSerch.find('.drill-down-list').scrollTop(DrillDownSerch.find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
  //         }
  //       } else {
  //         DrillDownSerch.find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //         DrillDownSerch.find('select').val('-1');
  //         const ddSearchValue = $(event.target).val().toLowerCase();
	// 	  var drilldownlistitemarray = DrillDownSerch.find('.drill-down-list-item');
  //         if (ddSearchValue !== '') {

	// 		  for(var i=0; i < drilldownlistitemarray.length;i++)
	// 		  {
	// 			var item = drilldownlistitemarray.eq(i);
	// 			item.html(item.attr('ogListValue'));
	// 			if (item.text().toLowerCase().indexOf(ddSearchValue) !== -1) {
  //               item.show();
  //               item.html(self.highlight(item.html(), ddSearchValue));
	// 			} else {
  //               item.hide();
	// 			}
	// 		}
  //           if (DrillDownSerch.find('.drill-down-list-item:visible').length === 0) {
  //             DrillDownSerch.removeClass('showDrillList');
  //           } else {
  //             DrillDownSerch.addClass('showDrillList');
  //           }
  //         } else {
  //           DrillDownSerch.find('.drill-down-list-item').show();
	// 		 for(var i=0; i < drilldownlistitemarray.length;i++)
	// 		 {
	// 			drilldownlistitemarray.eq(i).html(drilldownlistitemarray.eq(i).attr('ogListValue'));
	// 		 }
  //         }
  //         if($(event.target).val() != self.prevValue){
  //           self.checkDrillDown = 0;
  //         } else {
  //           self.checkDrillDown = 1;
  //         }
  //       }
  //     } else {
  //       DrillDownSerch.removeClass('showDrillList');
  //     }
  //   }, 1);
  // }
  // filterDDSearch(event) {
  //   var self = this;
  //   var keyCode = event.keyCode || event.which;
  //   if(keyCode == 13 || keyCode == undefined){
  //     event.preventDefault();
  //     $(event.target).blur();
  //     setTimeout(function (){
  //       $(event.target).closest('.drill-down-search').removeClass('showDrillList');
  //     }, 100);
  //   }
  //   setTimeout(function () {
  //     var keyCode = event.keyCode || event.which;
  //     if(keyCode !== 9){
  //       $(event.target).closest('.drill-down-search').addClass('showDrillList');
  //       if(keyCode == 40){
  //         event.preventDefault();
  //         if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'))){
  //           $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'));
  //           $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //           $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').addClass('currentActiveDDITem');
  //           $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
  //         } else {
  //           var nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').nextAll('.drill-down-list-item:visible:first');
  //           if(nextElement.length > 0){
  //             $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
  //             $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
  //             $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //             nextElement.addClass('currentActiveDDITem');
  //           } else {
  //             nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
  //             $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
  //             $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
  //             $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //             nextElement.addClass('currentActiveDDITem');
  //           }
  //         }

  //         var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
  //         var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
  //         var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
  //         var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

  //         if(elementPosWithHt > scrollableDivPosWithHt){
  //           $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
  //         } else if(elementPos < scrollableDivPos) {
  //           $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
  //         }

  //       } else if(keyCode == 38) {
  //         event.preventDefault();
  //         if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'))){
  //           $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'));
  //           $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //           $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').addClass('currentActiveDDITem');
  //           $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
  //         } else {
  //           // $(event.target).closest('.drill-down-search').find('select').val(parseInt($(event.target).closest('.drill-down-search').find('select').val()) - 1);
  //           // $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());

  //           var prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').prevAll('.drill-down-list-item:visible:first');
  //           if(prevElement.length > 0){
  //             $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
  //             $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
  //             $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //             prevElement.addClass('currentActiveDDITem');
  //           } else {
  //             prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
  //             $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
  //             $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
  //             $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //             prevElement.addClass('currentActiveDDITem');
  //           }
  //         }
  //         var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
  //         var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
  //         var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
  //         var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

  //         if(elementPosWithHt > scrollableDivPosWithHt){
  //           $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
  //         } else if(elementPos < scrollableDivPos) {
  //           $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
  //         }
  //       } else {
  //         $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
  //         $(event.target).closest('.drill-down-search').find('select').val('-1');
  //         const ddSearchValue = $(event.target).val().toLowerCase();
  //         if (ddSearchValue !== '') {
  //           $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
  //             $(this).html($(this).attr('ogListValue'));
  //             if ($(this).text().toLowerCase().indexOf(ddSearchValue) !== -1) {
  //               $(this).show();
  //               $(this).html(self.highlight($(this).html(), ddSearchValue));
  //             } else {
  //               $(this).hide();
  //             }
  //           });
  //           if ($(event.target).closest('.drill-down-search').find('.drill-down-list-item:visible').length === 0) {
  //             $(event.target).closest('.drill-down-search').removeClass('showDrillList');
  //           } else {
  //             $(event.target).closest('.drill-down-search').addClass('showDrillList');
  //           }
  //         } else {
  //           $(event.target).closest('.drill-down-search').find('.drill-down-list-item').show();
  //           $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
  //             $(this).html($(this).attr('ogListValue'));
  //           });
  //         }
  //         if($(event.target).val() != self.prevValue){
  //           self.checkDrillDown = 0;
  //         } else {
  //           self.checkDrillDown = 1;
  //         }
  //       }
  //     } else {
  //       $(event.target).closest('.drill-down-search').removeClass('showDrillList');
  //     }
  //   }, 1);
  // }

  setPrevValue(event){
    this.prevValue = $(event.target).val();
  }

  highlight(s, search) {
    return s.replace(new RegExp(
      search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'
    ), '<b>$&</b>');
  }

  getPipingTitle(group_no: number): string {
    return this.service.getPiping(group_no);
  }

  gotoNextQuestion(question: Questions, event) {
    this.service.gotoNextQuestion(question, event) ;
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }
}
